export default (anamesis) => {
    if (!anamesis.formData) {
        anamesis.formData = {}
    }
    return anamesis
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/initialize-implant-surgery-documentation.js